import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SchedulerService } from "../shared/services/scheduler/scheduler.service";
import { DataSource } from '@angular/cdk/table';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  displayedColumns: string[] = ["navigate", "reportName", "reportPeriod", "CreatedDate", "reportFormat", "isMail", "isScheduled", "emailTo"];
  dataSource = new MatTableDataSource();
  resultsLength = 0;
  isLoadingResults = true;
  numberOfRecordToBeProcessed = 20;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private schedulerService: SchedulerService) { }


  ngOnInit() {
    this.getMailLog("desc", this.numberOfRecordToBeProcessed, 1, true);
    this.getMailLog("desc", this.numberOfRecordToBeProcessed, 1, false);
  }

  ngAfterViewInit() {

    if (this.sort) {
      this.sort.sortChange.subscribe(() => {
        //
        this.paginator.pageIndex = 0;
        this.isLoadingResults = true;
        this.getMailLog(this.sort.direction, this.numberOfRecordToBeProcessed, this.paginator.pageIndex, false);
      });
    }
  }

  getMailLog(sort: string, limit: number, page: number, isCount: boolean) {
    this.schedulerService.getMailLog("createdAt-" + sort, limit, page, isCount)
      .subscribe((r) => {
        this.dataSource.data = r && r.length > 0 ? r : [];
        this.resultsLength = isCount && r && r.count > 0 ? r.count : this.resultsLength;
        this.isLoadingResults = false;
      });
  }

  getNextRecord() {
    this.getMailLog(this.sort.direction, this.numberOfRecordToBeProcessed, this.paginator.pageIndex, false);
  }

  downloadUrl(url) {
    window.open(url);
  }
  
  getPeriod(fromD){
    let fd = "";
    if(fromD)
       fd = fromD + " to ";
    return fd;
  }

  getDownloadIcon(type : string) {
    if (type.toLowerCase() == "excel")
    {
      return "flaticon-excel-file";
    }
    else if (type.toLowerCase() == "csv")
    {
      return "flaticon-csv-file-format-extension";
    }
    else
    {
      return "flaticon-pdf-file-format-symbol";
    }
  }

}





// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/reports/reports.component.ts